import { TicketsViewType } from 'routes/Tickets/TicketsViewType'

export enum FilterType {
  CLIENT = 1,
  WALLET = 2,
  TRADING_ACCOUNT = 3,
  ACCOUNT_GROUP = 4,
  INTRODUCING_BROKER = 5,
  INTRODUCING_BROKER_PROFILE = 6,
  TicketOverviewBackOffice = 7,
  CROSS_WALLET_OVERVIEW = 8,
  WALLET_TRADING_ACCOUNTS = 9,
  WALLET_DEPOSIT_WITHDRAWAL = 10,
  PAYMENT_AGENT = 11,
  PaymentAgentWalletTransferOverview = 12,
  DEALS = 13,
  LEADS = 14,
  TicketOverviewPayments = 15,
  TicketOverviewCompliance = 16,
  TicketOverviewSales = 17,
  TicketOverviewTranslations = 18,
  WalletTransferOverview = 19,
  IB_COMMISSIONS = 20,
  TradingAccountAdjustmentsOverview = 21,
  BonusTransferOverview = 22,
  WELCOME_TRADING_ACCOUNT = 23,
  DEMO_TRADING_ACCOUNT = 24,
  MARKETING_CAMPAIGNS_OVERVIEW = 25,
  IB_CASHBACK = 26,
  WorldCheckCaseStatusOverview = 27,
  TicketOverviewMyTickets = 28,
  SubscriptionsOverview = 29,
  TicketOverviewBrokerage = 30,
  CustomDividendsOverview = 31,
  UnsubscribeRequests = 32,
  SystematicCorporateActionsOverview = 33,
  AllowedPaymentProviders = 34,
  InterestRateOverview = 35,
  MarketingIbLandingsOverview = 36,
  Emails = 37,
  Versions = 38,
  FeatureFlags = 39,
  PlatformVersions = 40,
  PaymentProviderConfig = 41,
  PlatformConfigurations = 42,
  TransactionOverviewWalletOrClient = 43,
  NotificationOverview = 44,
  PlatformDownloadLinks = 45,
  Affiliates = 46,
  BonusCampaignOverview = 47,
  SwapFreeOptions = 48,
  CampaignMarginBonusResults = 49,
  RATE_MARKUPS = 50,
  IB_PROFILE_COMMISSIONS = 51,
  PLATFORM_TRANSACTIONS = 52,
  ReferralMaterialsCategories = 53,
  ReferralMaterials = 54,
  // TradingPoolResults = 55,
}

export enum FilterTypeName {
  CLIENT = 'Client Overview',
  WALLET = 'Wallet Overview',
  TRADING_ACCOUNT = 'Trading Account Overview',
  ACCOUNT_GROUP = 'Account Group Overview',
  INTRODUCING_BROKER = 'Introducing Broker Overview',
  INTRODUCING_BROKER_PROFILE = 'Introducing Broker Profile Overview',
  TicketOverviewBackOffice = 'Ticket Overview Backoffice',
  CROSS_WALLET_OVERVIEW = 'Cross-Wallet Transfer Overview',
  WALLET_TRADING_ACCOUNTS = 'Wallet-Trading-Account Transfer Overview',
  WALLET_DEPOSIT_WITHDRAWAL = 'Wallet-Deposit-Withdrawal Transfer Overview',
  PAYMENT_AGENT = 'PaymentAgent Overview',
  PaymentAgentWalletTransferOverview = 'PaymentAgent Wallet Transfer Overview',
  DEALS = 'Deals Overview',
  LEADS = 'Leads Overview',
  TicketOverviewPayments = 'Ticket Overview Payments',
  TicketOverviewSales = 'Ticket Overview Sales',
  TicketOverviewTranslations = 'Ticket Overview Translations',
  WalletTransferOverview = 'Wallet Transfer Overview',
  IB_COMMISSIONS = 'IB Commissions Transfer Overview',
  TradingAccountAdjustmentsOverview = 'Trading Account Adjustments Overview',
  BonusTransferOverview = 'Bonus Transfer Overview',
  MARKETING_CAMPAIGNS_OVERVIEW = 'Marketing Campaigns Overview',
  WorldCheckCaseStatusOverview = 'WorldCheck Case Status Overview',
  SubscriptionsOverview = 'Subscriptions Overview',
  TicketOverviewMyTickets = 'Ticket Overview My Tickets',
  DividendsOverview = 'Dividends Overview',
  TicketOverviewBrokerage = 'Ticket Overview Brokerage',
  AllowedPaymentProviders = 'Allowed PSPs',
  MarketingIbLandingsOverview = 'Marketing IB Landings Overview',
  Emails = 'Emails',
  Versions = 'Versions',
  FeatureFlags = 'Feature Flags',
  PlatformVersions = 'Platform Versions',
  PlatformConfigurations = 'Platform Configurations',
  TransactionOverviewWalletOrClient = 'Transaction Overview Wallet or Client',
  NotificationOverview = 'Notification Overview',
  RATE_MARKUPS = 'Rate Markups Overview',
  IB_PROFILE_COMMISSIONS = 'IB Profile Commissions Overview',
  CampaignMarginBonusResults = 'Campaign Margin Bonus Results',
  PLATFORM_TRANSACTIONS = 'Platform Transactions Overview',
  ReferralMaterialsCategories = 'Referral Materials Categories',
  ReferralMaterials = 'Referral Materials',
  UnsubscribeRequests = 'Unsubscribe Requests Overview',
}

export const getTicketFilterType = (ticketsViewType: TicketsViewType) => {
  switch (ticketsViewType) {
    case TicketsViewType.BackOffice:
      return FilterType.TicketOverviewBackOffice
    case TicketsViewType.Compliance:
      return FilterType.TicketOverviewCompliance
    case TicketsViewType.Payments:
      return FilterType.TicketOverviewPayments
    case TicketsViewType.Sales:
      return FilterType.TicketOverviewSales
    case TicketsViewType.Translation:
      return FilterType.TicketOverviewTranslations
    case TicketsViewType.MyTickets:
      return FilterType.TicketOverviewMyTickets
    case TicketsViewType.Brokerage:
      return FilterType.TicketOverviewBrokerage
    default:
      throw new TypeError('Ticket view type not found')
  }
}

export { Filter } from './Filter'
export { InputFilterCell } from './FilterCell'
export { HeaderSortCell } from './HeaderCell/HeaderSortCell'
